import { render } from "./DevBox.vue?vue&type=template&id=212a1867"
import script from "./DevBox.vue?vue&type=script&lang=js"
export * from "./DevBox.vue?vue&type=script&lang=js"

import "./DevBox.vue?vue&type=style&index=0&id=212a1867&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__